import api from '../../api'

export type ReprocessRainforestEventResult = {
  eventType: string
}

export const reprocessRainforestEvent = async (payload: string): Promise<ReprocessRainforestEventResult> => {
  return (await api.post('/web/admin/rainforest-events/reprocess', { payload })).data
}
